// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"96490659","364":"82df3d46","411":"bd38c9cd","693":"f7cf78ca","768":"27aa1fa1","800":"24f9ac1b","802":"4c04715e","832":"ad1ae6b6","837":"f4199aeb"}[chunkId] + ".chunk.js";
};